import React, { useEffect, useState } from "react";
import "../AboutUs/AboutUs.css";
import ContactForm from "../Contact/ContactForm";
import img1 from "../../assets/AboutUsImages/1.jpg";
import img2 from "../../assets/AboutUsImages/4w.jpg";
import img3 from "../../assets/AboutUsImages/2.jpg";
import img4 from "../../assets/AboutUsImages/3.jpg";
import Aos from "aos";
import "aos/dist/aos.css";
import whatsappimg from "../../assets/whatsapp.png";
import phoneImg from "../../assets/reciever.png";

const AboutUs = () => {
  useEffect(() => {
    Aos.init({ duration: 2000 });
  }, []);

  const [screenDimensions, setScreenDimensions] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  const [isChatOpen, setIsChatOpen] = useState(false);
  const [message, setMessage] = useState("");

  const whatsappNumber = "+971565443552";

  useEffect(() => {
    window.scrollTo(0, 0);
    function handleResize() {
      setScreenDimensions({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // Page par aate hi 2 seconds baad popup open ho
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsChatOpen(true);
    }, 2000); // 2000 milliseconds

    return () => clearTimeout(timer);
  }, []);

  const handleWhatsappClick = () => {
    setIsChatOpen(true);
  };

  const handlePhoneButton = () => {
    window.location.href = `tel:${whatsappNumber}`;
  };

  const handleSendMessage = () => {
    const text = message.trim() || "Hi I want to know more about your services";
    const url = `https://wa.me/${whatsappNumber.replace(
      "+",
      "",
    )}?text=${encodeURIComponent(text)}`;
    window.open(url, "_blank");
  };

  return (
    <>
      <div className="aboutUs">
        <div
          className="container-fluid"
          style={{
            backgroundColor: "rgba(0, 0, 0, 0.4)",
            height: "100vh",
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <h2 className="text-white text-center py-5 font-face-re">ABOUT US</h2>
        </div>
      </div>

      {/* Phone floating button */}
      <div
        style={{
          position: "fixed",
          bottom: "70px",
          right: "20px",
          zIndex: "9999",
          height: "50px",
          width: "50px",
        }}
      >
        <img
          src={phoneImg}
          style={{
            height: "50px",
            width: "50px",
            borderRadius: "50px",
            cursor: "pointer",
          }}
          onClick={handlePhoneButton}
          alt="phoneImg"
          loading="lazy"
        />
      </div>

      {/* WhatsApp floating button */}
      <div
        style={{
          position: "fixed",
          bottom: "10px",
          right: "20px",
          zIndex: "9999",
          height: "50px",
          width: "50px",
        }}
      >
        <img
          src={whatsappimg}
          style={{
            height: "50px",
            width: "50px",
            borderRadius: "50px",
            cursor: "pointer",
          }}
          onClick={handleWhatsappClick}
          alt="whatsappimg"
          loading="lazy"
        />
      </div>

      {/* WhatsApp chat popup */}
      {isChatOpen && (
        <div
          style={{
            position: "fixed",
            bottom: "70px",
            right: "80px",
            width: "320px",
            maxWidth: "90vw",
            backgroundColor: "#ffffff",
            borderRadius: "12px",
            boxShadow:
              "0 2px 10px rgba(0,0,0,0.15), 0 0 0 1px rgba(0,0,0,0.05)",
            zIndex: "10000",
            overflow: "hidden",
            fontFamily: "inherit",
          }}
        >
          {/* Header */}
          <div
            style={{
              backgroundColor: "#25D366",
              color: "#ffffff",
              padding: "10px 12px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <div>
              <div style={{ fontSize: "14px", fontWeight: "600" }}>
                Chat with us on WhatsApp
              </div>
              <div style={{ fontSize: "12px", opacity: 0.9 }}>
                Usually replies quickly
              </div>
            </div>
            <button
              onClick={() => setIsChatOpen(false)}
              style={{
                background: "transparent",
                border: "none",
                color: "#ffffff",
                fontSize: "18px",
                cursor: "pointer",
                lineHeight: 1,
              }}
            >
              ×
            </button>
          </div>

          {/* Body */}
          <div style={{ padding: "10px 12px", fontSize: "14px" }}>
            <div
              style={{
                backgroundColor: "#f0f0f0",
                borderRadius: "8px",
                padding: "8px 10px",
                marginBottom: "8px",
              }}
            >
              <span style={{ fontWeight: 600 }}>Hello</span>
              <div>How can we help you</div>
            </div>
            <div style={{ fontSize: "12px", color: "#999999" }}>
              This is a preview chat. When you click Send we will open WhatsApp
            </div>
          </div>

          {/* Input area */}
          <div
            style={{
              borderTop: "1px solid #e0e0e0",
              padding: "8px 10px",
              display: "flex",
              gap: "6px",
              alignItems: "center",
            }}
          >
            <input
              type="text"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              placeholder="Write your message"
              style={{
                flex: 1,
                border: "1px solid #dddddd",
                borderRadius: "20px",
                padding: "6px 12px",
                fontSize: "13px",
                outline: "none",
              }}
            />
            <button
              onClick={handleSendMessage}
              style={{
                backgroundColor: "#25D366",
                color: "#ffffff",
                border: "none",
                borderRadius: "20px",
                padding: "6px 12px",
                fontSize: "13px",
                cursor: "pointer",
                fontWeight: 500,
              }}
            >
              Send
            </button>
          </div>
        </div>
      )}

      <div className="First container-fluid text-black">
        <div className="container py-5">
          <h1 className="font-face-re">
            PERGOLA ROOMS BUILDING CONTRACTING LLC
          </h1>
          <p className="font-face-rr">
            Established several years ago, Pergola Rooms Building Contracting
            LLC has garnered a strong reputation as a premier provider of
            exceptional outdoor living solutions. Specializing in Pergolas,
            Glass Rooms, Bar and BBQ Counters, and Aluminium Doors and Fences,
            we offer a comprehensive range of services to transform your outdoor
            space into a haven of comfort and style.
          </p>
          <p className="font-face-rr">
            Our team of seasoned professionals combines technical expertise with
            a deep understanding of design aesthetics, ensuring that every
            project we undertake is executed with precision and attention to
            detail. From concept to completion, we work closely with our
            clients, taking their vision and transforming it into reality.
          </p>
          <p className="font-face-rr">
            At Pergola Rooms Building Contracting LLC, we pride ourselves on
            delivering innovative designs, superior craftsmanship, and
            unparalleled customer service. Whether you desire a cozy stunning
            Glass Room, or a functional BBQ area, we are committed to exceeding
            your expectations and creating outdoor spaces that enhance your
            lifestyle.
          </p>
          <p className="font-face-rr">
            Pergolas | Glass Rooms | Villa extention/ patio | BBQ area
          </p>
        </div>
      </div>

      <div className="container py-5">
        <div
          className="row"
          style={{
            position: "relative",
            alignItems: "end",
            marginBottom: "80px",
          }}
          data-aos="fade-up"
          data-aos-duration="2000"
        >
          <div
            style={{
              backgroundImage: `url('${img4}')`,
              minHeight: "600px",
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
            className="col-lg-6 shadow"
          ></div>
          <div className="col-lg-6">
            <div className="spacer text-black">
              <div className="inner p-lg-5">
                <h3 className="py-2 font-face-re">OUR PRINCIPLES</h3>
                <p className="font-face-rr">
                  We embrace customization, tailoring designs to reflect your
                  unique style and complement your home perfectly. Above all,
                  customer satisfaction is our priority, providing personalized
                  service and exceeding expectations. With these principles, we
                  have established ourselves as a trusted name in the industry.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div
          className="row ethics-second"
          style={{
            position: "relative",
            alignItems: "end",
            marginBottom: "80px",
          }}
          data-aos="fade-up"
          data-aos-duration="2000"
        >
          <div className="col-lg-6 spacerCol">
            <div className="spacer-right text-black">
              <div className="inner-right p-lg-5">
                <h3 className="py-2 font-face-re">WORK ETHICS</h3>
                <p className="font-face-rr">
                  We believe in transparent communication, timely delivery, and
                  exceptional craftsmanship. By embodying these work ethics, we
                  have earned the trust and loyalty of our valued clients.
                  Experience the Pergolarooms difference today and witness our
                  unwavering commitment to excellence in all that we do.
                </p>
              </div>
            </div>
          </div>

          <div
            style={{
              backgroundImage: `url('${img3}')`,
              minHeight: "600px",
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
            className="col-lg-6 shadow"
          ></div>
        </div>

        <div
          className="row"
          style={{
            position: "relative",
            alignItems: "end",
            marginBottom: "80px",
          }}
          data-aos="fade-up"
          data-aos-duration="2000"
        >
          <div
            style={{
              backgroundImage: `url('${img2}')`,
              minHeight: "600px",
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
            className="col-lg-6 shadow"
          ></div>
          <div className="col-lg-6">
            <div className="spacer text-black">
              <div className="inner p-lg-5">
                <h3 className="py-2 font-face-re">WHAT WE DO</h3>

                <p className="font-face-rr">
                  We offer premium quality aluminium works including Pergolas,
                  glass rooms, Bar and BBQ Counters, and doors and fences. With
                  our technical expertise and attention to detail, we bring your
                  outdoor visions to life, creating exceptional spaces that
                  stand the test of time. Trust Pergolarooms for all your
                  outdoor living needs.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div
          className="row ethics-fourth"
          style={{
            position: "relative",
            alignItems: "end",
            marginBottom: "80px",
          }}
          data-aos="fade-up"
          data-aos-duration="2000"
        >
          <div className="col-lg-6 spacerCol">
            <div className="spacer-right text-black">
              <div className="inner-right p-lg-5">
                <h3 className="py-2 font-face-re">UNRIVALLED EXPERIENCE</h3>

                <p className="font-face-rr">
                  Our functional BBQ areas, stylish Bar and BBQ Counters, and
                  durable aluminium pergolas are specifically engineered to
                  endure Dubai's weather conditions. Trust our legacy of
                  innovative craftsmanship to elevate your outdoor living
                  experience in Dubai. Experience the difference at Pergolarooms
                  today.
                </p>
              </div>
            </div>
          </div>

          <div
            style={{
              backgroundImage: `url('${img1}')`,
              minHeight: "600px",
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
            className="col-lg-6 shadow"
          ></div>
        </div>
      </div>
      <div id="contact-us">
        <ContactForm />
      </div>
    </>
  );
};

export default AboutUs;
